<template>
  <div v-if="computedCarte" :class="['carte', 'carte-depth-0', 'carte-' + display]">
    <div class="title">{{ computedCarte.title }}</div>
    <p v-if="computedCarte.description" class="description" v-html="computedCarte.description"></p>
    <div v-if="computedCarte.chapters" class="child-carte">
      <CarteChapterDisplay v-for="(chapter, index) in computedCarte.chapters" :chapter="chapter" :depth="1" :key="index" />
    </div>
  </div>
</template>

<script>
import CarteChapterDisplay from '@/components/CarteChapterDisplay'

export default {
  name: 'CarteDisplay',
  components: { CarteChapterDisplay },
  props: ['carte', 'display'],
  asyncComputed: {
    computedCarte() {
        return this.carte
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/style/settings.scss";
$titleSize: 2.25em;

.carte {
  margin-bottom: 2.5em;
  .title {
    text-transform: uppercase;
  }
  .description {
    white-space: pre-wrap;
    font-size: .8em;
  }
  @media (min-width: $media-m) {
    :not(.carte-depth-0) {
      .child-carte {
        margin-left: $spacing * .3;
        padding-left: $spacing * 1.5;
        border-left: 2px solid rgba(255,255,255,.5);
      }
    }
  }
}
.menu-items {
  display: table;
  width: 100%;
}
.menu-item {
  display: table-row;
  .item-count {
    font-size: small;
    // font-style: italic;
  }
  .item-comment {
    font-size: small;
    font-style: italic;
  }
  .item-prop {
    padding: .8em 0;
    display: table-cell;
    border-bottom: 1px dashed rgba(255,255,255,.1);

    vertical-align: middle;
    &.item-referral {
      vertical-align: top;
    }
    &.item-description {
      padding-left: 1em;
      padding-right: 1em;
    }
    &:last-child {
      text-align: right;
    }
  }
  &:last-child {
    .item-prop {
      border-bottom: none;
    }
  }
}

@for $i from 0 through 10 {
  .carte-depth-#{$i} {
    .title {
      font-size: $titleSize - ($i * .5em);
      // position: sticky;
      // top: calc(#{$navbar-offset} + (#{$titleSize} * #{$i}));
    }
  }
}

.carte-paper {
  // position: relative;
  display: inline-block;
  margin: 2em auto;
  padding: 2em 2em;
  background: #fff;
  background-image: url("/paper.png");
  border-radius: 2px;
  box-shadow: 0 10px 6px -6px #000;
  transition: all .3s ease-in-out;
  text-shadow: none;
  color: rgb(39, 35, 35);
}
</style>
